export default "__VITE_ASSET__BLfEN2j9__"